import React, {useCallback, useEffect} from 'react';
import EmptyList from "../../../../../components/EmptyList/EmptyList";
import s from "../../flows.module.scss";
import CustomSkeleton from "../../../../../components/UiKit/CustomSkeleton/CustomSkeleton";
import ExpiredTd from "./ExpiredTd";
import {useDispatch, useSelector} from "react-redux";
import {fetchExpiredDomainsList, flowSelector} from "../../../../../redux/slices/flowSlice";
import {globalDataSelector} from "../../../../../redux/slices/globalDataSlice";
import {useSearchParams} from "react-router-dom";
import {
    INVALID_PAGE_ERROR,
} from "../../../../../utils/vars/staticVariables";
import {useTranslation} from "react-i18next";
import {flowsExpiredTabColumnsList} from "../../../../../utils/vars/params";
import {getTableDefaultParams} from "../../../../../api/helpers/scripts";
import {page} from "../../../Statistics/IOS/IOSClicksStats/IOSClicksStats";
import useSetSearchParams from "../../../../../hooks/useSetSearchParams";

const ExpiredTab = ({onDuplicateFlowHandler}) => {
    const {flowsListPending, flowsList, totalCount} =
        useSelector(flowSelector);
    const {
        geoListPending,
    } = useSelector(globalDataSelector);

    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const updateSearchParams = useSetSearchParams(setSearchParams);

    const {t} = useTranslation();

    const fetchExpiredFlows = useCallback(() => {
        const promise = dispatch(
            fetchExpiredDomainsList(
                getTableDefaultParams({
                    searchParams,
                    defaultPageSize: 25,
                }),
            ),
        );

        promise.unwrap().catch((err) => {
            if (err?.message === INVALID_PAGE_ERROR) {
                updateSearchParams(page, 1);
            }
        });

        return promise;
    }, [dispatch, searchParams, updateSearchParams]);

    useEffect(() => {
        const promise = fetchExpiredFlows();

        return () => {
            promise.abort();
        };
    }, [dispatch, searchParams]);

    const expiredTabTableThead = <thead>
    <tr>
        {flowsExpiredTabColumnsList.map(({name}) => (
            <th key={name}>
                <div className={s.headerContent}>
                    {t(name)}
                </div>
            </th>
        ))}
    </tr>
    </thead>

    return (
        <>
            {totalCount === 0 && !flowsListPending ? (
                <EmptyList/>
            ) : flowsListPending || geoListPending ? (
                <section className={s.body}>
                    <table>
                        {expiredTabTableThead}
                    </table>
                    <div className={s.skeletonWrapper}>
                        <CustomSkeleton styles={s.skeletonTable}/>
                    </div>
                </section>
            ) : (
                <section className={s.body}>
                    <table>
                        {expiredTabTableThead}
                        <tbody>
                        {flowsList.map((item) => (
                            <ExpiredTd
                                key={item.id}
                                {...item}
                                onDuplicateFlowHandler={onDuplicateFlowHandler}
                            />
                        ))}
                        </tbody>
                    </table>
                </section>
            )}
        </>
    )
}

export default ExpiredTab;